const app = {
  state: {
    comments: '',
    upload: {
      media_name: '',
      media_id: '',
      url: '',
      file: null,
      type: 1,
      popFlag: false,
      popFlag2: false
    },
    audio: {
      media_name: '',
      media_id: '',
      url: '',
      file: null,
      type: 2,
      popFlag: false,
      popFlag2: false
    },
    attachmentFilesList: [],
    selectedFiles: [],
    part_comments: '',
    part_upload: {
      media_name: '',
      media_id: '',
      url: '',
      file: null,
      type: 1,
      popFlag: false,
      popFlag2: false
    },
    part_audio: {
      media_name: '',
      media_id: '',
      url: '',
      file: null,
      type: 2,
      popFlag: false,
      popFlag2: false
    },
    part_attachmentFilesList: [],
    part_selectedFiles: [],
    // 教师评分
    score: 0,
    answerMsg: {
      msg: '',
      msg_id: 0,
      msg_pid: ''
    },
    leveldata: [],
    students_answer: {},
    overall: ''
  },
  mutations: {
    setComments (state, comments) {
      state.comments = comments
    },
    setUpload (state, obj) {
      state.upload = Object.assign({}, state.upload, obj)
    },
    setAudio (state, obj) {
      state.audio = Object.assign({}, state.audio, obj)
    },
    setAttachmentFilesList (state, attachmentFilesList) {
      state.attachmentFilesList = attachmentFilesList
    },
    setSelectedFiles (state, selectedFiles) {
      state.selectedFiles = selectedFiles
    },
    setPartComments (state, part_comments) {
      state.part_comments = part_comments
    },
    setPartUpload (state, obj) {
      state.part_upload = Object.assign({}, state.part_upload, obj)
    },
    setPartAudio (state, obj) {
      state.part_audio = Object.assign({}, state.part_audio, obj)
    },
    setPartAttachmentFilesList (state, part_attachmentFilesList) {
      state.part_attachmentFilesList = part_attachmentFilesList
    },
    setPartSelectedFiles (state, part_selectedFiles) {
      state.part_selectedFiles = part_selectedFiles
    },
    setScore (state, score) {
      state.score = score
    },
    setAnswerMsg (state, msg) {
      state.answerMsg = Object.assign({}, state.answerMsg, msg)
    },
    setLevelData (state, leveldata) {
      state.leveldata = leveldata
    },
    setStudentsAnswer (state, students_answer) {
      state.students_answer = students_answer
    },
    setOverall (state, overall) {
      state.overall = overall
    }
  },
  getters: {
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js